"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.erc721ContractsValidationSchemaCreator = void 0;
const yup_1 = require("yup");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
const yup_rules_eth_1 = require("@dzambalaorg/yup-rules-eth");
const types_1 = require("../../../../../types");
const erc721ContractsValidationSchemaCreator = (service) => (0, yup_1.object)().shape({
    symbol: yup_rules_1.symbolValidationSchema,
    title: yup_rules_1.titleValidationSchema,
    description: yup_rules_1.draftValidationSchema,
    address: yup_rules_eth_1.addressValidationSchema,
    imageUrl: yup_rules_1.urlValidationSchema,
    ...(service === types_1.ServiceType.OFFICE && { merchantId: yup_rules_1.dbIdValidationSchema }),
});
exports.erc721ContractsValidationSchemaCreator = erc721ContractsValidationSchemaCreator;
//# sourceMappingURL=validation.js.map